import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Credly|Management|Badge Search|';
const sharedProperties: Pick<LocDef, 'shared' | 'feature' | 'portal'> = {
	shared: false,
	feature: HubFeature.ShareCredlyBadging,
	portal: 'SP',
};

type LocNameStart = 'SPCredlyManagementBadgeSearch';
export type SPCredlyManagementBadgeSearchLocNames =
	| `${LocNameStart}NotificationNoCandidateFound`
	| `${LocNameStart}NotificationExpiredCerts`
	| `${LocNameStart}NotificationNoCredlyData`
	| `${LocNameStart}ButtonViewCandidate`
	| `${LocNameStart}TitleDuplicateDataSection`;

export const spCredlyManagementBadgeSearchLocs: LocDefs<SPCredlyManagementBadgeSearchLocNames> = {
	SPCredlyManagementBadgeSearchNotificationNoCandidateFound: {
		defaultValue: 'No candidates found',
		description: 'No candidates found error',
		displayPath: `${pathStart}No candidates found`,
		displayType: 'Notification',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.Notification.NoCandidatesFound',
		htmlAllowed: false,
		...sharedProperties,
	},
	SPCredlyManagementBadgeSearchNotificationExpiredCerts: {
		defaultValue: 'Expired certs are being issued to Credly',
		description: 'Expired certs notification',
		displayPath: `${pathStart}Expired Certs`,
		displayType: 'Notification',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.Notification.ExpiredCerts',
		htmlAllowed: true,
		...sharedProperties,
	},
	SPCredlyManagementBadgeSearchNotificationNoCredlyData: {
		defaultValue: 'No Credly data was found for this candidate.',
		description: 'No Credly data notification',
		displayPath: `${pathStart}No Credly data`,
		displayType: 'Notification',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.NotificationMessage.NoCredlyData',
		htmlAllowed: false,
		...sharedProperties,
	},
	SPCredlyManagementBadgeSearchButtonViewCandidate: {
		defaultValue: 'View Candidate',
		description: 'View Candidate button',
		displayPath: `${pathStart}View Candidate`,
		displayType: 'Button',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.Button.ViewCandidate',
		htmlAllowed: false,
		...sharedProperties,
	},
	SPCredlyManagementBadgeSearchTitleDuplicateDataSection: {
		defaultValue: 'Duplicate Candidate Data',
		description: 'Duplicate Candidate Data title',
		displayPath: `${pathStart}Duplicate Candidate Data`,
		displayType: 'Title',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.Title.DuplicateDataSection',
		htmlAllowed: false,
		...sharedProperties,
	},
};

export type SPCredlyManagementBadgeSearchLocType = LocMap<SPCredlyManagementBadgeSearchLocNames>;
